import React from 'react';
import PropTypes from 'prop-types';
import {
  FlexContainer,
  Typography,
  Cushion,
  MaxWidth,
  Space,
  Button,
  Grid,
} from '@pitchero/react-ui';
import Icon from '../../icon';
import ClubLink from '../../club-link';
import AppInterceptedLink from '../../app-intercepted-link';
import { Trans } from '../../../lib/i18n';
import ProductList from '../product-list';

const LandingPageCategory = ({ isLoading, name, products, style }) => (
  <div style={style} className={`shop-landing-page__category-${name}`}>
    <Cushion
      top="medium"
      horizontal="small"
      component="div"
      responsive={[{ minWidth: 'tab', props: { horizontal: 'large' } }]}
    >
      <MaxWidth component="div" maxWidth={1366} center>
        <FlexContainer>
          <Typography preset="title" style={{ flex: 1 }}>
            {name}
          </Typography>
          {products.length > 3 && (
            <Typography color="primary" preset="button">
              <ClubLink route="shop.category" params={{ category: name }}>
                <AppInterceptedLink>
                  <>
                    <Trans i18nKey="common:view_all">View all &gt;</Trans>
                    <Space left="xsmall">
                      <Icon name="arrow-right" preset="button" color="primary" />
                    </Space>
                  </>
                </AppInterceptedLink>
              </ClubLink>
            </Typography>
          )}
        </FlexContainer>
      </MaxWidth>
    </Cushion>
    <Cushion
      top="medium"
      bottom="large"
      horizontal="small"
      component="div"
      responsive={[
        {
          minWidth: 'tab',
          props: {
            bottom: 'xlarge',
            top: 'large',
            horizontal: 'large',
          },
        },
      ]}
    >
      <MaxWidth component="div" maxWidth={1366} center>
        <ProductList isLoading={isLoading} products={products} />
        {products.length > 3 && (
          <Cushion
            top="medium"
            responsive={[{ minWidth: 'tab', props: { top: 'xlarge' } }]}
            component="div"
          >
            <Grid
              component="div"
              responsive={[
                { minWidth: 'tab', props: { columns: '300px', justifyContent: 'center' } },
              ]}
            >
              <ClubLink route="shop.category" params={{ category: name }}>
                <AppInterceptedLink style={{ width: '100%' }}>
                  <Button theme="textWithBorder" fullWidth>
                    <Trans i18nKey="common:view_all">View All</Trans>
                  </Button>
                </AppInterceptedLink>
              </ClubLink>
            </Grid>
          </Cushion>
        )}
      </MaxWidth>
    </Cushion>
  </div>
);

LandingPageCategory.defaultProps = {
  style: {},
};

LandingPageCategory.propTypes = {
  name: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  style: PropTypes.shape(),
};

export default LandingPageCategory;
